import React from "react";
import componentStyle from '@/styles/Component.scss';
import globalStyle from '@/styles/Global.scss';
import _ from "lodash";

const AttributeViewer = ({attributes = []}) => {
  return (
    <>
      <div className={componentStyle.inputArea}>
        {
          _.map(attributes,
            (a) => {
            return (
              <React.Fragment key={a.order}>
                <div className={globalStyle.attribute}>
                  <div className={globalStyle.title}>{ a.tag }</div>
                  <div className={globalStyle.value}>{ a.value }</div>
                </div>
              </React.Fragment>
            )
            })
        }
      </div>
    </>
  )
}
export default AttributeViewer
